// src/components/Footer.js
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        <div className="footer-section brand">
          <h2>WePrint PhotoBooks</h2>
          <p>We help you preserve life’s most precious moments with stunning, high-quality photo books.</p>
        </div>

        <div className="footer-section policies">
          <h3>Policies</h3>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
            <li><Link to="/cancellation-policy">Cancellation Policy</Link></li>
          </ul>
        </div>

        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/catalog">Catalog</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/testimonials">Testimonials</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section contact">
        <h3>Contact Us</h3>

        <p>
            <FontAwesomeIcon icon={faMapMarkerAlt} /> &nbsp;
            #37, Sannidhi Rd, NR Colony, Basavanagudi, Bengaluru, Karnataka 560004
        </p>

        <p>
            <FontAwesomeIcon icon={faPhoneAlt} /> &nbsp;
            <a href="tel:+918861494444">+91 88614 94444</a>
        </p>

        <p>
            <FontAwesomeIcon icon={faEnvelope} /> &nbsp;
            <a href="mailto:info@weprintphotobooks.com">info@weprintphotobooks.com</a>
        </p>

        <div className="social-icons">
            <a href="https://www.facebook.com/share/1D2ki8VsvP/" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://www.instagram.com/getweprint?igsh=MXB2OGx4Z3Jjemk1eQ==" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://youtube.com/@getweprint?si=ulmgX0RwcumcMTnT" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faYoutube} />
            </a>
        </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} WePrint PhotoBooks. All rights reserved.</p>
      </div>
    </footer>
  );
}
